import { customAlphabet, urlAlphabet } from 'nanoid';
export function getuuid({ alphabet = urlAlphabet, length = 16 } = {}) {
    const nanoid = customAlphabet(alphabet, length);
    return nanoid();
}
/**
 * 生成26个小写英文字母字符串数组
 */
export const getLowerCaseLetters = () => {
    const array = [];
    for (let i = 97; i < 123; i++) {
        array.push(String.fromCharCode(i));
    }
    return array;
};
/**
 * 生成 0-9 数字字符串数组
 */
export const getNumberLetters = () => {
    const array = [];
    for (let i = 48; i < 58; i++) {
        array.push(String.fromCharCode(i));
    }
    return array;
};
